export const {
  VITE_SENTRY_RELEASE: SENTRY_RELEASE,
  VITE_SENTRY_DSN: SENTRY_DSN,
  VITE_SENTRY_ENVIRONMENT: SENTRY_ENVIRONMENT,
  VITE_API_URL: API_URL,
  VITE_API_DOMAIN: API_DOMAIN,
  VITE_PUSH_NOTIFICATION_PUBLIC_KEY: PUSH_NOTIFICATION_PUBLIC_KEY,
  VITE_CABLE_URL: CABLE_URL,
  VITE_STRIPE_PUBLIC_KEY: STRIPE_PUBLIC_KEY,
} = import.meta.env;
